/* SRZ gift guard — keeps "Gifts on quantity" in sync with the cart.
   When the main product is removed (or its quantity drops below what a gift requires),
   every gift that depended on it is removed in a single /cart/update.js call (by line key,
   so removing several gifts at once can't hit the wrong line), then the cart UI is refreshed. */
(function () {
  if (window.SRZGiftGuard) return;

  var STORAGE_KEY = 'shrine_gift_goals';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null;
  var running = false;
  var again = false;

  function readGoals() {
    var goals = {};
    try {
      goals = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {}
    // gifts declared on the current page win over stored ones
    document.querySelectorAll('quantity-gifts[data-main-product]').forEach(function (el) {
      var byVariant = el.dataset.unlockBy === 'variant';
      el.querySelectorAll('.quantity-gift[data-handle]').forEach(function (gift) {
        goals[gift.dataset.handle] = {
          type: byVariant ? 'product_variant' : 'product_quantity',
          gift_handle: gift.dataset.handle,
          required_quantity: Number(gift.dataset.quantity) || 1,
          unlock_product_handle: el.dataset.mainProduct,
        };
      });
    });
    return Object.keys(goals)
      .map(function (k) {
        return goals[k];
      })
      .filter(function (g) {
        return g && g.gift_handle && g.unlock_product_handle && g.gift_handle !== g.unlock_product_handle;
      });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function giftKeysToRemove(cart, goals) {
    var qty = {};
    cart.items.forEach(function (item) {
      qty[item.handle] = (qty[item.handle] || 0) + item.quantity;
    });
    var updates = {};
    goals.forEach(function (g) {
      var have = qty[g.unlock_product_handle] || 0;
      // variant-based gifts only need the main product to be present
      var need = g.type === 'product_quantity' ? Number(g.required_quantity) || 1 : 1;
      if (have >= need) return;
      cart.items.forEach(function (item) {
        if (item.handle === g.gift_handle) updates[item.key] = 0;
      });
    });
    return updates;
  }

  function refreshCartUI() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.updateCart === 'function') drawerItems.updateCart();
    var pageItems = document.querySelector('cart-items');
    if (pageItems && typeof pageItems.updateCart === 'function') pageItems.updateCart();
  }

  function removeGifts(updates, retry) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      if (r.ok || !retry) return r.ok;
      // the theme may have removed one of them meanwhile: recompute against the fresh cart
      return getCart().then(function (cart) {
        var fresh = giftKeysToRemove(cart, readGoals());
        return Object.keys(fresh).length ? removeGifts(fresh, false) : true;
      });
    });
  }

  function check() {
    if (running) {
      again = true;
      return;
    }
    var goals = readGoals();
    if (!goals.length) return;
    running = true;
    getCart()
      .then(function (cart) {
        var updates = giftKeysToRemove(cart, goals);
        if (!Object.keys(updates).length) return false;
        return removeGifts(updates, true);
      })
      .then(function (changed) {
        if (changed) refreshCartUI();
      })
      .catch(function (err) {
        console.warn('[SRZ gift guard]', err);
      })
      .finally(function () {
        running = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    // let the theme's own cart requests settle first
    timer = setTimeout(check, 600);
  }

  document.addEventListener('cartQuantityUpdated', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  window.SRZGiftGuard = { check: check };
})();
